import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Footer } from '../components/Footer';
import { OnlineProjectPlanner } from '../components/OnlineProjectPlanner';
import { ArrowLeft } from 'lucide-react';

export function ProjectPlannerPage() {
  return (
    <div className="min-h-screen bg-zinc-900">
      <Helmet>
        <title>Online Project Planner | Golden Touch Contracting</title>
        <meta name="description" content="Plan your home improvement project and get an instant estimate with our online project planner. Simple, quick, and accurate estimates for your renovation needs." />
        <meta name="keywords" content="project planner, renovation estimate, home improvement calculator, construction cost estimator" />
      </Helmet>


      <main className="pt-24">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <Link to="/" className="inline-flex items-center gap-2 text-yellow-400 mb-12 hover:gap-4 transition-all duration-300">
            <ArrowLeft className="h-4 w-4" />
            <span className="text-sm tracking-wider">Back to Home</span>
          </Link>

          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-light text-zinc-100 mb-6">
              Online Project Planner
            </h1>
            <p className="text-zinc-400 max-w-2xl mx-auto leading-relaxed">
              Get an instant estimate for your home improvement project. Answer a few simple questions 
              about your project, and we'll provide you with a preliminary cost estimate.
            </p>
          </div>

          <OnlineProjectPlanner />
        </div>
      </main>

      <Footer />
    </div>
  );
}